module.exports = __webpack_public_path__ + "static/img/当当.1784171d.png";